function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, [{
    key: "execute",
    value: function execute(properties, component) {
      Utils.type.ifString(properties.channel, function (channelName) {
        var ws = window.vueApp.actionCable;
        var channel = ws.channels[channelName];
        console.log("Pushing to", channel);
        Utils.type.ifString(properties.event, function (eventName) {
          if (channel) {
            var payload = Object.assign({}, properties.payload, {
              formData: properties.formData
            });
            console.debug("Pushing to '".concat(channelName, "/").concat(eventName, "'"), payload);
            channel.perform(eventName, payload);
          } else {
            console.error("Channel not joined: '".concat(channelName, "'"));
            Utils.launch.snackbar.error("Something went wrong and we have been notified", component);
          }
        });
      });
    }
  }]);

  return _default;
}();

export { _default as default };